import React from 'react';
import AntDrawer from 'antd/lib/drawer';
import 'antd/lib/drawer/style/index.css';
import './Drawer.css'; // This needs to be removed once Drawers are upgraded to MUI

const Drawer = ({ children, ...rest }) => (
  <AntDrawer {...rest}>{children}</AntDrawer>
);

Drawer.defaultProps = {
  width: 400,
};

export default Drawer;
